<template>
	<v-row>
		<v-col>
			<base-material-card
				color="success"
				class="px-5 py-3"
			>
				<template #heading>
					<div class="d-flex">
						<div class="text-h3 font-weight-light">
							מפתחות
						</div>
						<v-spacer />
						<div class="text-left">
							<v-btn @click="onEdit({})">
								צור
							</v-btn>
						</div>
					</div>
				</template>
				<row>
					<c-col>
						<passports-table @edit="onEdit" />
					</c-col>
				</row>
				<popup-dialog v-model="openModal">
					<span slot="header">יצירת/עריכת מפתח</span>
					<passport-form @save="openModal=false" />
				</popup-dialog>
			</base-material-card>
		</v-col>
	</v-row>
</template>

<script>
import PassportModule from "src/store/modules/Passport.module";
import PassportsTable from "./PassportsTable";
import PassportForm from "./PassportForm";

export default {
	name: "PassportsView",
	components: { PassportsTable, PassportForm },
	props: {},
	data () {
		return {
			openModal: false,
		};
	},
	computed: {},
	created () {
	},
	methods: {
		onEdit (passport) {
			this.$store.commit(PassportModule.types.GET, passport);
			this.openModal = true;
		},
	},
};
</script>

<style scoped>

</style>
